import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { getProductsCart, removeProductCart } from 'actions'
import CommonModal from 'components/common/commonModal'
import CommonTable from 'components/common/commonTable'
import ConfirmModal from 'components/common/ConfirmModal'
import { P_INDIVIDUAL_TREASURY_ITEM_LOADING } from 'constants/ConfigProcessNames'
import { IFieldStructure } from 'constants/valuesInterfaces/interfaces'
import { getDefaultColumns } from 'lib/FormUtils'
import { IAuthUserProps } from 'models/Auth'
import { IConfigFieldsForm } from 'models/Budget'
import {
	ICartProductItem,
	IGetCartItemsParams,
	IRemoveProductCartParams,
	IShoppingCartItems
} from 'models/ShoppingCart'
import React, { Component, Fragment } from 'react'
import { Col } from 'react-bootstrap'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import {
	ILoadingTreasuryItemStore,
	IUpdateTreasuryProductItemStore
} from 'reducers/IndividualTreasuryItem'
import _ from 'underscore'
import IndividualTreasuryItem from './IndividualTreasuryItem'

interface IndividualTreasuryItemLoadingTableProps extends WithTranslation {
	idOperacion: string
	config: IConfigFieldsForm
	getProductsCart: (payload: IGetCartItemsParams) => void
	removeProductCart: (payload: IRemoveProductCartParams) => void
	productsCart: IShoppingCartItems
	loadedItems: ILoadingTreasuryItemStore
	t?: any
	authUser: IAuthUserProps
	updatedTreasuryProduct: IUpdateTreasuryProductItemStore
}

interface IndividualTreasuryItemLoadingTableState {
	tableColumns: Array<object>
	productItems: Array<ICartProductItem>
	idProduct: number
	showEditModal: boolean
	page_size: number
	page_number: number
}

export class IndividualTreasuryItemLoadingTable extends Component<
	IndividualTreasuryItemLoadingTableProps,
	IndividualTreasuryItemLoadingTableState
> {
	constructor(props: IndividualTreasuryItemLoadingTableProps) {
		super(props)
		this.state = {
			tableColumns: [],
			productItems: [],
			idProduct: 0,
			showEditModal: false,
			page_size: 10,
			page_number: 1
		}
	}

	componentDidMount = (): void => {
		const { config, idOperacion } = this.props
		if (!_.isEmpty(config)) {
			this.handleSetColumns(config.campos)
			this.props.getProductsCart({ idOperacion, page_number: 1, page_size: 10 })
		}
	}

	componentDidUpdate = (
		prevProps: Readonly<IndividualTreasuryItemLoadingTableProps>,
		prevState: Readonly<IndividualTreasuryItemLoadingTableState>,
		snapshot?: any
	): void => {
		const { config, loadedItems, productsCart, updatedTreasuryProduct } =
			this.props

		if (!_.isEqual(prevProps.config, config) && !_.isEmpty(config)) {
			this.handleSetColumns(config.campos)
		}

		this.handleLoadedItems(prevProps.loadedItems, loadedItems)
		this.handleLoadedItems(
			prevProps.updatedTreasuryProduct,
			updatedTreasuryProduct
		)

		this.handleValidateProducts(
			prevProps?.productsCart?.productos,
			productsCart?.productos
		)
	}

	handleValidateProducts = (
		prevProducts: Array<ICartProductItem>,
		products: Array<ICartProductItem>
	) => {
		if (
			!_.isEqual(prevProducts, products) &&
			!_.isNull(products) &&
			!_.isUndefined(products)
		) {
			this.setState({ productItems: products })
		}
	}

	handleLoadedItems = (prevLoadedItems: any, loadedItems: any) => {
		const { idOperacion } = this.props
		const { page_number, page_size } = this.state
		if (
			!_.isEqual(prevLoadedItems, loadedItems) &&
			!_.isEmpty(loadedItems) &&
			loadedItems.status === 'succeeded'
		) {
			this.props.getProductsCart({ idOperacion, page_number, page_size })
		}
	}

	handleSetColumns = (fields: Array<IFieldStructure>) => {
		const { t, authUser } = this.props

		if (!_.isEmpty(fields)) {
			const addColumn = [
				{
					dataField: 'actions',
					text: '',
					align: 'center',
					headerAlign: 'center',
					headerStyle: { width: '8%' },
					formatter: (cell: string, row: ICartProductItem) => {
						return (
							<Fragment>
								<FontAwesomeIcon
									icon={faPen}
									style={{ cursor: 'pointer' }}
									color={'#007bff'}
									onClick={() => this.handleEditItem(row)}
								/>
								<ConfirmModal
									messageBody={t('individual_treasury_items.remove_message')}
									onSubmitModal={() => this.handleRemoveCart(row)}
									labelButton={<FontAwesomeIcon icon={faTrash} />}
									modalTitle={t('shoppingCart.modal.title')}
									typeButton={'light'}
								/>
							</Fragment>
						)
					}
				}
			]

			const tableColumns = getDefaultColumns(fields, { authUser }, addColumn)
			this.setState({ tableColumns })
		}
	}

	handleEditItem = (row: ICartProductItem) => {
		this.setState({ idProduct: row.nitem, showEditModal: true })
	}

	/**
	 * to remove product of cart
	 * @param {object} row
	 */
	handleRemoveCart = (row: ICartProductItem) => {
		const { idOperacion } = this.props
		this.props.removeProductCart({
			idOperacion,
			nitem: row.nitem,
			page: 1,
			page_size: 10
		})
	}

	/**
	 * callback used when change of pagination
	 * @param type
	 * @param pagination
	 */
	handleChangeTable = (type: string, pagination: any) => {
		const { idOperacion } = this.props
		const { page, sizePerPage } = pagination
		this.setState({ page_number: page, page_size: sizePerPage })
		this.props.getProductsCart({
			idOperacion,
			page_number: page,
			page_size: sizePerPage
		})
	}

	handleCloseEditModal = () => {
		this.setState({ showEditModal: false })
	}

	render() {
		const { productsCart, config, idOperacion } = this.props
		const { tableColumns, productItems, idProduct, showEditModal } = this.state

		const options = !_.isEmpty(productsCart)
			? {
					page: productsCart.page_number,
					sizePerPage: productsCart.page_size,
					totalSize: productsCart.total_count
			  }
			: {}

		const tableProps = {
			remote: true,
			columns: tableColumns,
			keyField: 'nitem',
			data: productItems,
			paginationOptions: options,
			onTableChange: this.handleChangeTable
		}
		return (
			<Col sm={12}>
				<CommonModal
					sizeModal="lg"
					modalBody={
						<IndividualTreasuryItem
							fields={config.campos}
							product={idProduct}
							idOperacion={idOperacion}
							handleCloseModal={this.handleCloseEditModal}
						/>
					}
					modalTitle="Editar Item"
					showModal={showEditModal}
					handleCloseModal={this.handleCloseEditModal}
				/>

				{!_.isEmpty(tableColumns) && <CommonTable {...tableProps} />}
			</Col>
		)
	}
}

const mapStateToProps = ({
	voucher,
	product,
	individualTreasuryItem,
	auth
}: any) => {
	const config = voucher.config
		? voucher.config[P_INDIVIDUAL_TREASURY_ITEM_LOADING]
		: null

	const { productsCart } = product
	const { loadedItems, updatedTreasuryProduct } = individualTreasuryItem
	const { authUser } = auth

	return { config, productsCart, loadedItems, authUser, updatedTreasuryProduct }
}

const mapDispatchToProps = {
	getProductsCart,
	removeProductCart
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withTranslation()(IndividualTreasuryItemLoadingTable))
